// extracted by mini-css-extract-plugin
export default {"image":"TeamCard_image__vTot0","title":"TeamCard_title__9204J","para":"TeamCard_para__O3OCI","wrapper":"TeamCard_wrapper__CeaRH"};